import { render, staticRenderFns } from "./AktuelleLimits.vue?vue&type=template&id=2f37323d"
import script from "./AktuelleLimits.vue?vue&type=script&lang=js"
export * from "./AktuelleLimits.vue?vue&type=script&lang=js"
import style0 from "./AktuelleLimits.vue?vue&type=style&index=0&id=2f37323d&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f37323d')) {
      api.createRecord('2f37323d', component.options)
    } else {
      api.reload('2f37323d', component.options)
    }
    module.hot.accept("./AktuelleLimits.vue?vue&type=template&id=2f37323d", function () {
      api.rerender('2f37323d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AktuelleLimits.vue"
export default component.exports